// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__11l71","left":"InfoRow_left__1qfph"};